<template>
  <div v-if="newsEntries && newsEntries.length > 0">
    <div class="stack-sm">
        <news
          v-for="newsEntry in newsEntries"
          :key="newsEntry.id"
          :news-entry="newsEntry"
          :category="getCategory(newsEntry.news_category_id)"
        />
    </div>
    <load-more-section auto-load name="newsentry" @input="getNewsEntries" />
  </div>
</template>

<script>
const News = require("@/modules/home/components/News.vue").default;
const LoadMoreSection = require('@/modules/core/components/LoadMoreSection.vue').default;

export default {
  name: "NewsSite",
  data() {
    return {
      newsEntries: [],
      newsCategories: null,
    };
  },
  props: {},
  components: {
    News,
    LoadMoreSection
  },
  methods: {
    link(link) {
      this.$router.push("/home/" + link);
    },
    getCategory(CategoryId) {
      return this.newsCategories.find((e) => e.id === CategoryId);
    },
    async getNewsEntries(){
      this.newsEntries = await this.getEntity("newsentry", "PublishedIndex");
    }
  },
  computed: {},
  async created() {
    this.newsCategories = await this.$store.getters[
      "newscategory/api"
    ].GetAll();
    await this.getNewsEntries();

    this.$store.dispatch("header/updateTab", 1);
    this.$store.dispatch("header/update", {
      bg: "bg-primary-500",
      css: "text-black",
      tabs: {
        elements: [
          {
            bright: false,
            title: this.$t("home.home"),
            action: () => {
              this.link("dashboard");
            },
          },
          {
            bright: false,
            title: this.$t("home.news"),
            action: () => {
              this.link("news");
            },
          },
        ],
      },
    });
  },
};
</script>
